module.exports = __webpack_public_path__ + "assets/images/cavalo_ce7bf6ba5249190fef61fa1ec3f48428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela-de-desafio/icons/cavalo.png
// module id = 191
// module chunks = 0